import React, { useState } from 'react';
import '../../styles/AdminModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import useUserActions from '../../hooks/AdminUsersPage/useUserActions'; 

const UsersBulkDeleteModal = ({ isOpen, onClose, onSuccess, users }) => {
  const [loading, setLoading] = useState(false);
  const { handleBulkDelete } = useUserActions();

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await handleBulkDelete(users);
      await onSuccess();
      onClose();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Users</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="admin__modal-body">
          <div className="admin__modal-body__delete_users">
            <p>
              Are you sure you want to delete the following {users.length} {users.length === 1 ? 'user' : 'users'}?
            </p>
            <div className="admin__modal-body__delete_users_container">
              <ul>
                {users.map(user => (
                  <li key={user.id}>
                    <strong>{user.first_name} {user.last_name}</strong> (ID #{user.id})
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Processing...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Processing...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UsersBulkDeleteModal;